










































import { Component, Prop, Vue } from 'vue-property-decorator';
// tslint:disable-next-line
const noSsr = require('vue-no-ssr');

@Component({
  components: {
    'no-ssr': noSsr,
  },
})
export default class TrustpilotRating extends Vue {
  @Prop({ type: Boolean, default: false }) private readonly isExperiment!: boolean;
}
